import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { IAssociationContainer, IAssociationContainerReduxProps, ITarget } from '../../types/interfaces';

import AssociationTable from './AssociationTable';
import ClientTable from './ConsultationClientTable';
import EncaissementTable from './ConsultationEncaissementTable';
import AssociationEdit from './AssociationEdit';
import TableContainer from "../tables_manager/TableContainer"
import { SelectColumnFilter, NumberRangeColumnFilter } from '../tables_manager/filters';
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faCheck, faCheckCircle, faDollarSign, faExternalLinkAlt, faEye, faFileAlt, faFileInvoice, faInfoCircle, faPen, faPencilRuler, faPlug, faPlus, faTimes, faTrash } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import LinesEllipsis from 'react-lines-ellipsis'
import PDFLink from '../pdf/PDFLink';
import { constants } from '../../types/constants';
import { PRIVILEGE } from '../../types/privileges';

const AssociationContainer = ({ 
  associations,
  vente,
  etages,
  division,
  associationPartInfo,
  setAssociationPartInfo,
  setSelectedAssociationHandle,
  selectedFloor,
  setSelectedFloor,
  isModal,
  isChoosingPart,
  isDraft,
  hidePartsInfo,
  removeFloor,
  chooseForEnc,
  chooseAssociation,
  createRecu,
  user,
  auth
 }: IAssociationContainer) => {
  const {users} = user
  const [modalAssociation, setModalAssociation] = useState(false);
  const [modalAssociationData, setModalAssociationData] = useState<any>();
  const [showOnlyFloors, setShowOnlyFloors] = useState(false);
  const [showPrice, setShowPrice] = useState(false);

  useEffect(() => {
    if(associationPartInfo && setAssociationPartInfo)
      setAssociationPartInfo(e => associations?.find(t => t.id === e.id) || e)
  }, [associations])

  return (<>
    <Container className="linesConfirmationContainer fadeAnimation" style={{border: "none"}}>
      {etages ? <div style={{display: "flex", flexDirection: "row"}}>
        {/* <div> */}
          <div className={`buildingImg${isModal ? "" : " d-none d-md-block"}`} style={!isNaN(etages) ? {backgroundImage: `url('/images/floors/floor${Number(etages) <= 3 ? "2" : Number(etages) === 4 ? "3" : "4"}.png')`, height: Number(etages) <= 3 ? "200px" : Number(etages) === 4 ? "265px" : "320px"} : {}}></div>
        {/* </div> */}
        <div style={{flex: 1, display: "flex", flexDirection: "column-reverse"}}>
          {[...Array(Number(etages)).keys()].map((e, i) => {
            const floorParts = (associations || []).filter(t => t.ETAGE === e.toString())
            const floorDivision = division?.division_floors?.find(t => t.floor === e)
            return <div className="buildingRows" style={{marginBottom: e === 0 ? "54px" : "0px", border: "none", boxShadow: "none"}} key={i}>
              {floorDivision ? <div className="buildingPart" style={{width: "100%", position: "relative"}}>
                <div className={`buildingDivisionFloorBody${setSelectedFloor ? ` buildingDivisionFloorBodySelectable${selectedFloor?.id === floorDivision.id ? " buildingDivisionFloorBodySelected" : ""}` : ""}`} onClick={() => setSelectedFloor && setSelectedFloor(floorDivision)}>
                  <span className="buildingDivisionFloorBodySpan">
                    <span className="buildingPartPercent" style={{backgroundColor: "darkgreen"}}>{floorDivision.floor === 0 ? "RDC" : `Étage ${floorDivision.floor}`}</span>
                    {`${Number(floorDivision.totalPrice || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH`}
                    <span className="buildingPartPercent" style={{backgroundColor: "darkblue"}} title={floorDivision.division_floor_partition_types?.map(e => e.division_partition_type?.name)?.join(", ")}>{floorDivision.activePartitionType?.name || "..."}</span>
                  </span>
                  {!!auth?.user?.privileges?.includes(PRIVILEGE.WEBMASTER) && <FontAwesomeIcon icon={faPen} className="buildingFloorDivisionEdit" onClick={() => {alert("TO DO")}} />}
                </div>
                {!!(isDraft && floorDivision && removeFloor) && <FontAwesomeIcon icon={faTimes} className="buildingDivisionFloorDelete" title="Supprimer" onClick={() => removeFloor(floorDivision.index)} />}
                {!!(!showOnlyFloors && !isDraft) && <div className="buildingDivisionPartsContainer" style={{cursor: setSelectedFloor ? "pointer" : "default"}} onClick={() => setSelectedFloor && setSelectedFloor(floorDivision)}>
                  {(floorDivision.division_parts || []).map((e, key) => {
                    const association = floorParts.find(t => t.divisionPartId === e.id)
                    return <div className="buildingDivisionPartBody" style={{width: `${e.percent}%`}} key={key}>
                      <span className="buildingDivisionPartBodySpan">
                        <span className="buildingPartPercent" style={{backgroundColor: e.percent === 100 ? "darkgreen" : "darkblue"}}>{e.percent || 0}%</span>
                        &nbsp;{showPrice ? `${Number(association?.PRIX_VENTE || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH` : (association?.contrat_clients?.map(e => e.client ? `${e.client.NOM} ${e.client.PRENOM}` : "-").join(" / ") || "-")}
                        {!setSelectedFloor && <FontAwesomeIcon icon={faInfoCircle} className="libraryInfoTooltip" title="Plus d'informations" onClick={() => {!!(setAssociationPartInfo && association) && (associationPartInfo?.id === association.id ? setAssociationPartInfo('') : setAssociationPartInfo(association))}} />}
                      </span>
                    </div>
                  })}
                </div>}
              </div> : floorParts.length > 0 ? floorParts.map((t, key) => <div key={key} className="buildingPart" style={{width: t.POURCENTAGE ? `${t.POURCENTAGE}%` : "auto"}}>
                <div className={"buildingPartBody" + (associationPartInfo?.id === t.id ? " buildingPartBodySelected" : "")}>
                  <span className="buildingPartBodySpan" title={t.contrat_clients?.map(e => e.client ? `${e.client.NOM} ${e.client.PRENOM}` : "-").join(" / ")}>
                    <span className="buildingPartPercent" style={{backgroundColor: t.POURCENTAGE === 100 ? "darkgreen" : "darkblue"}}>{t.POURCENTAGE || 0}%</span>&nbsp;{t.contrat_clients?.map(e => e.client ? `${e.client.NOM} ${e.client.PRENOM}` : "-").join(" / ") || "-"}<FontAwesomeIcon icon={faInfoCircle} className="libraryInfoTooltip" title="Plus d'informations" onClick={() => {setAssociationPartInfo && (associationPartInfo?.id === t.id ? setAssociationPartInfo('') : setAssociationPartInfo(t))}} />
                  </span>
                </div>
              </div>) : <div className="buildingEmpty"><strong>{e === 0 ? "RDC" : `Étage ${e}`}</strong>{" pas encore vendu"}</div>}
            </div>
          })}
          <div className="partsBtnsContainer">
            {!!(division && !isDraft) && <FontAwesomeIcon icon={faDollarSign} className="partsBtns" style={showPrice ? {color: "green"} : {}} onClick={() => setShowPrice(e => !e)} />}
            {!!(division && !isDraft) && <FontAwesomeIcon icon={faBars} className="partsBtns" style={showOnlyFloors ? {color: "green"} : {}} onClick={() => setShowOnlyFloors(e => !e)} />}
          </div>
        </div>
      </div> : "Nombre d'étages non spécifié pour ce bien"}
      {!hidePartsInfo && (associationPartInfo ? <Container className="CardInfo fadeAnimation" style={{position: "relative", marginTop: "15px"}}>
        <div className="cardCloseBtn" onClick={() => setAssociationPartInfo && setAssociationPartInfo('')}></div>
        {chooseForEnc ? <Row className="justify-content-center">
          <Col xs="6" style={{display: "flex", alignItems: "center", justifyContent: "center", border: "none", borderRadius: "unset"}}>
            <Button
              className="btn btn-success addEncaissementLineBtn"
              style={{fontWeight: 600}}
              onClick={() => chooseForEnc(associationPartInfo)}
              ><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;{isChoosingPart ? "Choisir" : "Y ajouter un encaissement"}</Button>
          </Col>
        </Row>: null}
        {chooseAssociation ? <Row className="justify-content-center">
          <Col xs="6" style={{display: "flex", alignItems: "center", justifyContent: "center", border: "none", borderRadius: "unset"}}>
            <Button
              className="btn btn-success addEncaissementLineBtn"
              style={{fontWeight: 600}}
              onClick={() => chooseAssociation(associationPartInfo?.id)}
              ><FontAwesomeIcon icon={faCheck} />&nbsp;&nbsp;Choisir</Button>
          </Col>
        </Row>: null}
        <Row>
          <Col xs="6">
            <FontAwesomeIcon icon={faInfoCircle} />&nbsp;<strong>ID Système : </strong>{associationPartInfo.id || "-"}
          </Col>
          <Col xs="6">
            <FontAwesomeIcon icon={faInfoCircle} />&nbsp;<strong>Type : </strong>{associationPartInfo.TYPE === constants.APPARTEMENT ? "Appartement" : associationPartInfo.TYPE === constants.MAGASIN ? "Magasin" : (associationPartInfo.TYPE || "-")}
          </Col>
        </Row>
        <Row>
          <Col xs="6">
            <FontAwesomeIcon icon={faInfoCircle} />&nbsp;<strong>Étage : </strong>{associationPartInfo.ETAGE === "0" ? "RDC" : associationPartInfo.ETAGE}
          </Col>
          <Col xs="6">
            <FontAwesomeIcon icon={faInfoCircle} />&nbsp;<strong>Pourcentage : </strong>{associationPartInfo.POURCENTAGE || 0}%
          </Col>
        </Row>
        {!!(associationPartInfo.POSITION && associationPartInfo.SUPERFICIE) && <Row>
          <Col xs="6">
            <FontAwesomeIcon icon={faInfoCircle} />&nbsp;<strong>Position : </strong>{associationPartInfo.POSITION || "-"}
          </Col>
          <Col xs="6">
            <FontAwesomeIcon icon={faInfoCircle} />&nbsp;<strong>Superficie : </strong>{associationPartInfo.SUPERFICIE ? (associationPartInfo.SUPERFICIE + "m²") : "-"}
          </Col>
        </Row>}
        <Row>
          <Col xs="6">
            <FontAwesomeIcon icon={faInfoCircle} />&nbsp;<strong>Date Part : </strong>{associationPartInfo.originalDate ? moment(associationPartInfo.originalDate).format('DD/MM/YYYY') : "-"}
          </Col>
          <Col xs="6">
            <FontAwesomeIcon icon={faInfoCircle} />&nbsp;<strong>Commercial : </strong>{users.find(e => associationPartInfo.ID_COM && e.id === associationPartInfo.ID_COM)?.username || "-"}
          </Col>
        </Row>
        <Row>
          <Col xs="6">
            <FontAwesomeIcon icon={faInfoCircle} />&nbsp;<strong>Bénéf. Commission : </strong>{users.find(e => associationPartInfo.commissionedTo && e.id === associationPartInfo.commissionedTo)?.username || "-"}
          </Col>
          <Col xs="6">
            <FontAwesomeIcon icon={faInfoCircle} />&nbsp;<strong>Chargé de Part : </strong>{users.find(e => associationPartInfo.charge_bien_id && e.id === associationPartInfo.charge_bien_id)?.username || "-"}
          </Col>
        </Row>
        {associationPartInfo.createdAt || associationPartInfo.createdBy ? <Row>
          <Col xs="6">
            <FontAwesomeIcon icon={faInfoCircle} />&nbsp;<strong>Saisie le : </strong>{associationPartInfo.createdAt ? moment(associationPartInfo.createdAt).format('DD/MM/YYYY - HH:mm') : "-"}
          </Col>
          <Col xs="6">
            <FontAwesomeIcon icon={faInfoCircle} />&nbsp;<strong>Saisie par : </strong>{users.find(e => associationPartInfo.createdBy && e.id === associationPartInfo.createdBy)?.username || "-"}
          </Col>
        </Row> : null}
        {!!associationPartInfo.OBSERVATION && <Row>
          <Col xs="12">
            <FontAwesomeIcon icon={faInfoCircle} />&nbsp;<strong>Commentaire : </strong>{associationPartInfo.OBSERVATION || "-"}
          </Col>
        </Row>}
        <Row className="justify-content-center">
          <Col xs="6" className="text-center">
            <FontAwesomeIcon icon={faInfoCircle} />&nbsp;<strong>Prix de vente : </strong>{(associationPartInfo.PRIX_VENTE !== null && associationPartInfo.PRIX_VENTE !== undefined && associationPartInfo.PRIX_VENTE != "") ? (associationPartInfo.PRIX_VENTE.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"}
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col xs="6" className="text-center">
            <FontAwesomeIcon icon={faInfoCircle} />&nbsp;<strong>Avance : </strong>{associationPartInfo.contrat_encaissements ? (associationPartInfo.contrat_encaissements.reduce((e, t) => {
              return t.PART ? e + Number(t.PART) : e
            }, 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"}
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col xs="6" className="text-center" style={(associationPartInfo.PRIX_VENTE !== null && associationPartInfo.PRIX_VENTE !== undefined && associationPartInfo.PRIX_VENTE != "" && associationPartInfo.contrat_encaissements) && (associationPartInfo.PRIX_VENTE - associationPartInfo.contrat_encaissements.reduce((e, t) => {
              return t.PART ? e + Number(t.PART) : e
            }, 0)) < 0 ? {color: "red"} : {}}>
            <FontAwesomeIcon icon={faInfoCircle} />&nbsp;<strong>Reliquat : </strong>{(associationPartInfo.PRIX_VENTE !== null && associationPartInfo.PRIX_VENTE !== undefined && associationPartInfo.PRIX_VENTE != "" && associationPartInfo.contrat_encaissements) ? ((associationPartInfo.PRIX_VENTE - associationPartInfo.contrat_encaissements.reduce((e, t) => {
              return t.PART ? e + Number(t.PART) : e
            }, 0)).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"}
          </Col>
        </Row>
        {!!(auth?.user?.privileges?.includes(PRIVILEGE.EDIT_ASSOCIATION) || auth?.user?.privileges?.includes(PRIVILEGE.WEBMASTER)) && <div style={{display: "flex", justifyContent: "space-between", fontStyle: "italic", fontSize: "x-small"}}>
          {!!(auth?.user?.privileges?.includes(PRIVILEGE.WEBMASTER) && createRecu) && <div className="consultationEditBtn" onClick={() => createRecu(true, associationPartInfo.id)}><FontAwesomeIcon icon={faPencilRuler} />&nbsp;<div style={{textDecoration: "underline"}}>Générer un reçu</div></div>}
          <div className="consultationEditBtn" onClick={() => {setModalAssociationData(associationPartInfo); setModalAssociation(true)}}><FontAwesomeIcon icon={faPen} />&nbsp;<div style={{textDecoration: "underline"}}>Modifier</div></div>
          {!!setSelectedAssociationHandle && <div className="consultationEditBtn" onClick={() => setSelectedAssociationHandle(associationPartInfo)}><FontAwesomeIcon icon={faFileAlt} />&nbsp;<div style={{textDecoration: "underline"}}>Reçus des paiements</div></div>}
        </div>}
        {!!vente && <Row className="justify-content-center">
          <PDFLink documentType={"part"}
            data={{...associationPartInfo, hasPermission: vente?.hasPermission, contrat_encaissements: vente?.contrat_encaissements?.filter(e => e.ID_ASS == associationPartInfo.id), contrat_clients: vente?.contrat_clients?.filter(e => e.ID_ASS == associationPartInfo.id), contrat: vente || {}}}
            download={false}
            buttonText="Fiche Part"
            customClassNames="btn btn-success linesConfirmationBtn linesDeleteBtn pl-3 pr-3 mb-2"
            customButtonIcon={faFileInvoice}
            iconSize="inherit"
            allowPrintPreview={true}
            style={{marginRight: "20px", marginLeft: "20px", fontWeight: 600}} />
        </Row>}
        <Row style={{padding: "12px 0 0", marginBottom: "-10px"}}>
          <h3>Clients</h3>
        </Row>
        <Row className="justify-content-center">
          <ClientTable linesData={associationPartInfo?.contrat_clients?.filter(e => !!e.client).map(e => e.client) || []} embed />
        </Row>
        <Row style={{padding: "12px 0 0", marginBottom: "-10px"}}>
          <h3>Encaissements</h3>
        </Row>
        <Row className="justify-content-center">
          <EncaissementTable linesData={associationPartInfo?.contrat_encaissements?.filter(e => !!e.encaissement).map(e => ({...e.encaissement, ...e})) || []} embed />
        </Row>
      </Container> : (!!associations && <AssociationTable linesData={associations.sort((a, b) => Number(a.ETAGE || 0) - Number(b.ETAGE || 0))} setAssociationPartInfo={setAssociationPartInfo} vente={vente} chooseAssociation={chooseAssociation} embed />))}
    </Container>
    {!!associations && <AssociationEdit modal={modalAssociation} setModal={setModalAssociation} modalData={modalAssociationData} selectedBien={{
      ETAGE_ASS: etages,
      contrat: {associations},
      division
    }} />}
  </>);
};

const mapStateToProps = (state: IAssociationContainerReduxProps) => ({
  user: state.user,
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, {})(AssociationContainer);
